import useBranches from "./useBranches";

const useGetBranch = (branchId: number) => {
  const branches = useBranches();
  const branch = branches.find((br) => br.branch.id === branchId);
  return branch;
};

export default useGetBranch;
